const modulesFiles = require.context('./modules', true, /\.js$/)
const api = modulesFiles.keys().reduce((modules, modulePath) => {
  const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1')
  if (modulePath.indexOf('index.js') > -1) {
    const value = modulesFiles(modulePath)
    const name = moduleName.replace(/(.*)\/index/, '$1')
    modules[name] = value.default
  }
  return modules
}, {})

export default api




// WEBPACK FOOTER //
// ./src/api/api.js